var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../config/config';
import { VisitorSettingsCommand, } from '../../../commands/pagination.query.command';
import { BaseComponent } from '../../../common/components/base.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { WaterFallContainerComponent } from '../../../common/components/water.fall.container/water.fall.container.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { clone } from '../../../common/extensions';
import { AuthService } from '../../../common/services/auth.service';
import { ModalService } from '../../../common/services/modal.service';
import { HubEvent } from '../../../models/hub/hub.event';
import { HubPlace } from '../../../models/hub/hub.place';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { EditorChoiceStore } from '../../../stores/hub.calendar.store';
import { AllFrontendSettingsStore, VisitorCalendarStore, VisitorDataCache, VisitorSettingsStore, } from '../../../stores/visitor.calendar.store';
import { EventDetailsModalComponent } from '../event.details.modal/event.details.modal.component';
import { EventDetailsModalActions } from '../event.details.modal/event.details.modal.provider';
import { PlaceDetailsModalComponent } from '../place.details.modal/place.details.modal.component';
import { PlaceDetailsModalActions } from '../place.details.modal/place.details.modal.provider';
import { TripDetailModalActions, TripDetailModalData } from '../trip/trip.detail.modal/trip.detail.modal.provider';
import { TripDetailModalComponent } from '../trip/trip.detail.modal/trip.detail.modal.component';
var VisitorCalendarComponent = /** @class */ (function (_super) {
    __extends(VisitorCalendarComponent, _super);
    function VisitorCalendarComponent(router, activatedRoute, authService, modalService, editorChoiceStore, customizationApiService, visitorCalendarStore, allFrontendSettingsStore, visitorSettingsStore, visitorApiService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.authService = authService;
        _this.modalService = modalService;
        _this.editorChoiceStore = editorChoiceStore;
        _this.customizationApiService = customizationApiService;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.visitorSettingsStore = visitorSettingsStore;
        _this.visitorApiService = visitorApiService;
        _this.settingsCommand = new VisitorSettingsCommand();
        _this.isNoContent = false;
        _this.isContentLoaded = false;
        _this.isCalendarStyleLoaded = false;
        _this.calendarCardWidth = config.calendarCardDefaultWidth;
        _this.maxColumn = 6;
        return _this;
    }
    VisitorCalendarComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, category = _a.category, customEventBtnId = _a.customEventBtnId, customPlaceBtnId = _a.customPlaceBtnId, placeId = _a.placeId, eventId = _a.eventId, categoryList = _a.categoryList, menuType = _a.menuType;
        this.hubName = hubName;
        this.customEventBtnId = customEventBtnId;
        this.customPlaceBtnId = customPlaceBtnId;
        this.category = category;
        this.placeDetailsId = placeId;
        this.eventDetailsId = eventId;
        this.processScriptSolution();
        /**
         * take the all frontend custom settings from visitor.component
         */
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            console.log('frontend settings get in store');
            _this.frontendSettings = command;
            _this.editorChoiceStore.infoCommand.next(_this.frontendSettings.customSettings.customEditorChoice);
            _this.isCalendarStyleLoaded = true;
        });
        /**
         * take the action command from visitor.side.bar or top.bar and get corresponding data (event/places)
         */
        this.visitorCalendarStore.actionCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            console.log('command got', command);
            if (!!_this.actionCommand && _this.actionCommand.isEventCalendar !== command.isEventCalendar) {
                return;
            }
            // visitor.components.ts uses this to handle browser's back button event
            localStorage.setItem(localStorageKeys.eventQueryCommand, JSON.stringify(command));
            console.log('command set', command);
            _this.showSpinner();
            // this.customEventBtnId || this.customPlaceBtnId means directly visit the custom button page, command.queryCommand.isCustom means click the custom button in the dropdown
            if ((_this.customEventBtnId || _this.customPlaceBtnId) && !command.queryCommand.isCustom) {
                _this.loadCustomBtns(command);
            }
            else {
                _this.loadItems(command);
            }
        });
    };
    VisitorCalendarComponent.prototype.processScriptSolution = function () {
        /** for clients who use the script solution (embed Imgoing script into their website)
         if a place name + Id is specified (by imgoing-place), then go to the place details page after load
         */
        if (this.isScriptSolution) {
            if (window.location.search) {
                console.log(window.location.search);
                if (window.location.search.indexOf('imgoing-place=') >= 0) {
                    var nameId = window.location.search.split('imgoing-place=')[1].split('&')[0];
                    if (nameId.indexOf('-') >= 0) {
                        var nameIdSeg = nameId.split('-');
                        this.placeDetailsId = nameIdSeg[nameIdSeg.length - 1];
                        console.log("this.placeDetailsId: " + this.placeDetailsId);
                    }
                    else {
                        console.log("nameId not processed: " + nameId);
                    }
                }
                if (window.location.search.indexOf('imgoing-event=') >= 0) {
                    var nameId = window.location.search.split('imgoing-event=')[1].split('&')[0];
                    if (nameId.indexOf('-') >= 0) {
                        var nameIdSeg = nameId.split('-');
                        this.eventDetailsId = nameIdSeg[nameIdSeg.length - 1];
                        console.log("this.eventDetailsId: " + this.eventDetailsId);
                    }
                    else {
                        console.log("nameId not processed: " + nameId);
                    }
                }
            }
        }
    };
    VisitorCalendarComponent.prototype.loadMore = function () {
        this.actionCommand.queryCommand.page++;
        if (this.actionCommand.isEventCalendar) {
            this.getEvents(true);
        }
        else {
            this.getPlaces(true);
        }
    };
    VisitorCalendarComponent.prototype.loadCustomBtns = function (command) {
        var _this = this;
        if (this.customEventBtnId) {
            this.customizationApiService.getCustomEvent(this.hubName).subscribe(function (custom) {
                var customBtn = custom.customEvents.first(function (x) { return x._id.toString() === _this.customEventBtnId; });
                if (customBtn) {
                    command.queryCommand.isCustom = true;
                    command.queryCommand.selectedEvents = customBtn.events;
                    _this.loadItems(command, 'event');
                }
                else {
                    alert('Wrong custom event button Id, please check!');
                }
            });
        }
        else if (this.customPlaceBtnId) {
            // this.customizationApiService.getCustomEvent(this.hubName).subscribe((custom) => {
            //     let customBtn = custom.customPlaces.first((x) => x._id.toString() === this.customPlaceBtnId);
            //     if (customBtn) {
            //         command.queryCommand.isCustom = true;
            //         command.queryCommand.type = this.customPlaceBtnId;
            //         command.queryCommand.selectedPlaces = null;
            //         this.loadItems(command, 'place');
            //     } else {
            //         alert('Wrong custom place button Id, please check!');
            //     }
            // });
            command.queryCommand.isCustom = true;
            command.queryCommand.type = this.customPlaceBtnId;
            command.queryCommand.selectedPlaces = null;
            this.loadItems(command, 'place');
        }
    };
    VisitorCalendarComponent.prototype.getEvents = function (isLoadMore) {
        var _this = this;
        if (isLoadMore === void 0) { isLoadMore = false; }
        this.isAllDataLoaded = false;
        var loadEvents = function () {
            _this.visitorApiService.getEvents(_this.hubName, _this.actionCommand.queryCommand).subscribe(function (data) {
                _this.processCalendarStyle();
                _this.afterGotEvents(isLoadMore, data);
            });
        };
        try {
            loadEvents();
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.hideSpinner();
            // setTimeout(() => {
            //     // on Safari, sometimes the events cannot be loaded in the first time
            //     if (this.isMobile && isSafari()) {
            //         loadEvents();
            //     }
            // });
        }
    };
    VisitorCalendarComponent.prototype.getPlaces = function (isLoadMore) {
        var _this = this;
        if (isLoadMore === void 0) { isLoadMore = false; }
        this.isAllDataLoaded = false;
        var loadPlaces = function () {
            // for map view
            localStorage.setItem(localStorageKeys.selectedPlaceCategory, _this.actionCommand.queryCommand.category);
            _this.actionCommand.queryCommand.source = _this.frontendSettings.dataSource
                ? _this.frontendSettings.dataSource.place
                : 'facebook';
            _this.visitorApiService.getPlaces(_this.hubName, _this.actionCommand.queryCommand).subscribe(function (data) {
                _this.processCalendarStyle();
                _this.afterGotPlaces(isLoadMore, data);
            });
        };
        try {
            loadPlaces();
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.hideSpinner();
            // setTimeout(() => {
            //     if (this.isMobile && isSafari()) {
            //         loadPlaces();
            //     }
            // });
        }
    };
    VisitorCalendarComponent.prototype.loadItems = function (command, type) {
        var _this = this;
        if (type) {
            command.isEventCalendar = type === 'event';
        }
        this.actionCommand = clone(command);
        this.isNoContent = false;
        this.waterFallContainer && this.waterFallContainer.startLoading();
        setTimeout(function () {
            console.log('this.frontendSettings', _this.frontendSettings);
            if (!_this.frontendSettings) {
                _this.getCustomerSettings().subscribe(function (settings) {
                    _this.frontendSettings = settings;
                    _this.isCalendarStyleLoaded = true;
                    command.isEventCalendar ? _this.getEvents() : _this.getPlaces();
                });
            }
            else {
                command.isEventCalendar ? _this.getEvents() : _this.getPlaces();
            }
        }, 100);
    };
    VisitorCalendarComponent.prototype.getCustomerSettings = function () {
        var _this = this;
        return Observable.create(function (observable) {
            try {
                _this.customizationApiService.getAllFrontendSettings(_this.hubName).subscribe(function (settings) {
                    if (!settings)
                        return;
                    try {
                        _this.setCustomerColor(settings.customSettings.Style);
                        observable.next(settings);
                        observable.complete();
                    }
                    catch (e) {
                        observable.error(e);
                    }
                });
            }
            catch (e) {
                observable.error(e);
            }
        });
    };
    VisitorCalendarComponent.prototype.afterGotEvents = function (isLoadMore, data) {
        var _this = this;
        if (!isLoadMore &&
            !this.frontendSettings.customSettings.menuStyle.isSideBar &&
            !this.frontendSettings.customSettings.visitorPromotion.isDisabled &&
            this.frontendSettings.customSettings.visitorPromotion.image) {
            var promotion = new HubEvent();
            promotion.isPromotionImage = true;
            promotion.cover = { source: '', isDefault: false };
            promotion.cover.source = this.frontendSettings.customSettings.visitorPromotion.image.toString();
            promotion.pinnedTime = new Date();
            promotion.promotionLink = this.frontendSettings.customSettings.visitorPromotion.link.toString();
            data.unshift(promotion);
        }
        if (!isLoadMore) {
            this.events = data;
        }
        else {
            // for mobile view safari, as it loads twice to avoid not loading issue, so here is to filter duplicated items
            var filteredData = data.filter(function (x) { return !_this.events.any(function (y) { return y._id === x._id; }); });
            this.events = this.events.concat(filteredData);
        }
        this.isContentLoaded = true;
        // localStorage.setItem(localStorageKeys.visitorEvents, JSON.stringify(this.events));
        VisitorDataCache.events = this.events;
        if (data.length === 0) {
            this.isAllDataLoaded = true;
        }
        this.waterFallContainer.reLayout();
        this.checkIsNoContent();
        if (this.eventDetailsId && !isLoadMore) {
            var event_1 = this.events.first(function (x) { return x._id === _this.eventDetailsId; });
            if (event_1) {
                event_1.hubName = this.hubName;
            }
            var actions = {
                confirm: function (event, data) {
                },
            };
            if (this.isMobile) {
                this.showDetailModalForMobile(event_1 || { eventId: this.eventDetailsId }, 'event');
            }
            else {
                this.modalService.show({
                    component: EventDetailsModalComponent,
                    providers: [
                        { provide: EventDetailsModalActions, useValue: actions },
                        { provide: HubEvent, useValue: event_1 || { hubName: this.hubName, _id: this.eventDetailsId } },
                    ],
                    panelClass: 'modal-fixed-top-lower',
                });
            }
        }
        console.log('events loaded');
        this.customEventBtnId = null;
        this.customPlaceBtnId = null;
        !isLoadMore && this.hideSpinner();
    };
    VisitorCalendarComponent.prototype.afterGotPlaces = function (isLoadMore, data) {
        var _this = this;
        if (!isLoadMore &&
            !this.frontendSettings.customSettings.menuStyle.isSideBar &&
            !this.frontendSettings.customSettings.visitorPromotion.isDisabled &&
            this.frontendSettings.customSettings.visitorPromotion.image) {
            if (!config.hidePromotionImageForPlaces.any(function (x) { return x.toLocaleLowerCase() === _this.hubName.toLowerCase(); })) {
                if (this.frontendSettings.customSettings.calendarStyle.place !== 'tile') {
                    var promotion = new HubPlace();
                    promotion.isPromotionImage = true;
                    promotion.cover = {
                        source: this.frontendSettings.customSettings.visitorPromotion.image,
                        isDefault: false,
                    };
                    promotion.pinnedTime = new Date();
                    promotion.promotionLink = this.frontendSettings.customSettings.visitorPromotion.link;
                    data.unshift(promotion);
                }
            }
        }
        if (!isLoadMore) {
            this.places = data;
        }
        else {
            this.places = this.places.concat(data);
        }
        this.isContentLoaded = true;
        localStorage.setItem(localStorageKeys.visitorPlaces, JSON.stringify(this.places));
        if (data.length === 0) {
            this.isAllDataLoaded = true;
        }
        this.waterFallContainer.reLayout();
        this.checkIsNoContent();
        if (this.placeDetailsId && !isLoadMore) {
            var place = this.places.first(function (x) { return x._id === _this.placeDetailsId; });
            //if (place) {
            var actions = {
                confirm: function (event, data) {
                },
            };
            if (this.isMobile) {
                this.showDetailModalForMobile(place || { placeId: this.placeDetailsId }, 'place');
            }
            else {
                this.modalService.show({
                    component: PlaceDetailsModalComponent,
                    providers: [
                        { provide: PlaceDetailsModalActions, useValue: actions },
                        {
                            provide: HubPlace,
                            useValue: place || { hubName: this.hubName, placeId: this.placeDetailsId },
                        },
                    ],
                    panelClass: 'modal-fixed-top',
                });
            }
        }
        !isLoadMore && this.hideSpinner();
    };
    VisitorCalendarComponent.prototype.showDetailModalForMobile = function (item, displayingOn, isShowAddToTripBtn, index) {
        if (isShowAddToTripBtn === void 0) { isShowAddToTripBtn = false; }
        var actions = {
            confirm: function (event) {
            },
        };
        this.modalService.show({
            component: TripDetailModalComponent,
            providers: [
                { provide: TripDetailModalActions, useValue: actions },
                {
                    provide: TripDetailModalData,
                    useValue: new TripDetailModalData(item, displayingOn, this.hubName, null, null, isShowAddToTripBtn, index),
                },
            ],
            panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
        });
    };
    VisitorCalendarComponent.prototype.setCustomerColor = function (data) {
        if (!data) {
            return;
        }
        var head = document.getElementsByTagName('head')[0];
        var s = document.createElement('style');
        s.setAttribute('type', 'text/css');
        var css = '';
        if (data.defaultButton.backgroundColor) {
            css += "--default-btn-background-color: " + data.defaultButton.backgroundColor + ";";
        }
        if (data.eventButton.backgroundColor) {
            css += "--event-btn-background-color: " + data.eventButton.backgroundColor + ";";
        }
        if (data.placeButton.backgroundColor) {
            css += "--place-btn-background-color: " + data.placeButton.backgroundColor + ";";
        }
        if (data.pinnedEventBorder.borderColor) {
            css += "--pinned-event-border-color: " + data.pinnedEventBorder.borderColor + ";";
        }
        if (data.detailButton.backgroundColor) {
            css += "--detail-btn-background-color: " + data.detailButton.backgroundColor + ";";
        }
        s.appendChild(document.createTextNode("\n                :root {\n                  " + css + "\n                }\n            "));
        head.appendChild(s);
        // setTimeout(() => {
        //     this.spinner.hide();
        // });
    };
    VisitorCalendarComponent.prototype.checkIsNoContent = function () {
        if ((!this.events || !this.events.length) && (!this.places || !this.places.length)) {
            this.isNoContent = true;
        }
        // if ((this.events.length === 1 && this.events[0].isPromotionImage) || (this.places.length === 1 && this.places[0].isPromotionImage)) {
        //     this.isNoContent = true;
        // }
    };
    VisitorCalendarComponent.prototype.processCalendarStyle = function () {
        if (this.actionCommand.isEventCalendar) {
            if (this.frontendSettings.customSettings.calendarStyle.event === 'square') {
                this.calendarCardWidth = config.calendarCardSquareWidth;
            }
            else if (this.frontendSettings.customSettings.calendarStyle.event === 'long') {
                this.calendarCardWidth = config.calendarCardLongWidth;
                this.maxColumn = 4;
            }
        }
        else {
            if (this.frontendSettings.customSettings.calendarStyle.place === 'square' ||
                this.frontendSettings.customSettings.calendarStyle.place === 'tile') {
                this.calendarCardWidth = config.calendarCardSquareWidth;
            }
            else if (this.frontendSettings.customSettings.calendarStyle.place === 'long') {
                this.calendarCardWidth = config.calendarCardLongWidth;
                this.maxColumn = 4;
            }
        }
    };
    VisitorCalendarComponent.prototype.showSpinner = function () {
        this.spinner.show();
    };
    VisitorCalendarComponent.prototype.hideSpinner = function () {
        var _this = this;
        setTimeout(function () {
            _this.spinner.hide();
        });
    };
    return VisitorCalendarComponent;
}(BaseComponent));
export { VisitorCalendarComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/visitor.calendar.component.ts.pre-build-optimizer.js